import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  username = '';
  password = '';
  error = '';
  currentYear: number = new Date().getFullYear();
  constructor(private auth: AuthService, private router: Router) {}

  login() {
    this.auth.login(this.username, this.password).subscribe({ next: (res) => {
      if (res && res.token) this.router.navigate(['/admin/dashboard']);
      else this.error = res.message || 'Login failed';
    }, error: (err) => { this.error = 'Login error'; } });
  }
}
